"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.useShouldRedirectToAccountIfLoggedIn = useShouldRedirectToAccountIfLoggedIn;
const config_1 = __importDefault(require("@src/config"));
const account_context_1 = require("@src/context/account-context");
function useShouldRedirectToAccountIfLoggedIn(pathWithoutRedirect) {
    const account = (0, account_context_1.useAccount)();
    const isUserLoggedIn = Boolean(account);
    const userAccount = (account === null || account === void 0 ? void 0 : account.accountTypeId) === config_1.default.accountType.company ? '/admin' : '/ucet';
    return isUserLoggedIn ? userAccount : pathWithoutRedirect;
}
